import {
  ADD_ITEMS_TO_SHOPPING_CART,
  DELETE_ITEM_TO_SHOPPING_CART,
  ADD_PERSONAL_DATA_TO_SHOPPING_CART,
  CHANGE_IS_GITFT,
  ADD_NOTES,
  USE_CRIS_DATA,
  RESET_CART,
  DELETE_ITEM_TO_SHOPPING_CART_BY_ID,
} from 'constants/shopping-cart';

export const addItemsShoppingCartAction = (data) => ({
  type: ADD_ITEMS_TO_SHOPPING_CART,
  payload: data,
});

export const deleteItemsShoppingCartAction = (index) => ({
  type: DELETE_ITEM_TO_SHOPPING_CART,
  payload: index,
});

export const addPersonalDataToShoppingCartAction = (index, membersList) => ({
  type: ADD_PERSONAL_DATA_TO_SHOPPING_CART,
  payload: { index, membersList },
});

export const changeIsGiftAction = (index, value) => ({
  type: CHANGE_IS_GITFT,
  payload: { index, value },
});

export const addNotesAction = (index, notes) => ({
  type: ADD_NOTES,
  payload: { index, notes },
});

export const useCrisDataAction = (index, value) => ({
  type: USE_CRIS_DATA,
  payload: { index, value },
});

export const resetExp = () => ({
  type: RESET_CART,
  payload: null,
});

export const deleteItemToShoopingCartById = (id) => ({
  type: DELETE_ITEM_TO_SHOPPING_CART_BY_ID,
  payload: id,
});
